var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryActive = function SvgCategoryActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 46"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "category-active_svg__a",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "category-active_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#category-active_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#111",
    strokeWidth: 3,
    d: "M52.5 51.5v1h-47v-1zm-36-20v1h-11v-1zm0-20v1h-11v-1z",
    mask: "url(#category-active_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#111",
    strokeWidth: 4,
    mask: "url(#category-active_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    x: 2,
    y: 2,
    rx: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 32-8-8"
  }))))));
};
export default SvgCategoryActive;